import { ColorType } from 'ngx-lib';
import { OpportunityStatuses } from './OpportunityStatuses';

export const StatusMap: Record<number, { icon: string; text: string; colorType: ColorType }> = {
    [OpportunityStatuses.Accepted]: {
        icon: 'accepted',
        text: 'Accepted',
        colorType: 'success'
    },
    [OpportunityStatuses.InProgress]: {
        icon: 'inProgress',
        text: 'In Progress',
        colorType: 'info'
    },
    [OpportunityStatuses.Canceled]: {
        icon: 'canceled',
        text: 'Canceled',
        colorType: 'error'
    },
    [OpportunityStatuses.InReview]: {
        icon: 'inReview',
        text: 'In Review',
        colorType: 'pending'
    },
    [OpportunityStatuses.OnHold]: {
        icon: 'onHold',
        text: 'On-Hold',
        colorType: 'idle'
    },
    [OpportunityStatuses.Rejected]: {
        icon: 'rejected',
        text: 'Rejected',
        colorType: 'error'
    },
    [OpportunityStatuses.Submitted]: {
        icon: 'submitted',
        text: 'Submitted',
        colorType: 'pending'
    },
    [OpportunityStatuses.Ready]: {
        icon: 'ready',
        text: 'Ready',
        colorType: 'pending'
    },
    [OpportunityStatuses.BidRequested]: {
        icon: 'bidRequested',
        text: 'Bid Requested',
        colorType: 'idle'
    },
    [OpportunityStatuses.Unqualified]: {
        icon: 'edit',
        text: 'Unqualified',
        colorType: 'idle'
    },
    [OpportunityStatuses.Disqualified]: {
        icon: 'disqualified',
        text: 'Disqualified',
        colorType: 'error'
    }
};
